"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSelectPlayerCtl = /** @class */ (function (_super) {
    __extends(DlgSelectPlayerCtl, _super);
    function DlgSelectPlayerCtl() {
        return _super.call(this, true) || this;
    }
    DlgSelectPlayerCtl.prototype.ResetData = function () {
        this.DATA = {
            onClose: null,
            onSelect: null,
            onReLoadData: null,
            visible: false,
            data: [],
            title: "",
            columnValueTitle: "",
            filterVal: ""
        };
    };
    DlgSelectPlayerCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSelectPlayerCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSelectPlayerCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectPlayerCtl.prototype, "onClose", {
        get: function () {
            return this.DATA.onClose;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectPlayerCtl.prototype.SetOnCloseClick = function (callback) {
        this.DATA.onClose = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectPlayerCtl.prototype, "OnSelect", {
        get: function () {
            return this.DATA.onSelect;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectPlayerCtl.prototype.SetOnSelectClick = function (callback) {
        this.DATA.onSelect = callback;
        this.Update();
        return this;
    };
    DlgSelectPlayerCtl.prototype.SetOnReLoadData = function (callback) {
        this.DATA.onReLoadData = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectPlayerCtl.prototype, "onReLoadData", {
        get: function () {
            return this.DATA.onReLoadData;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectPlayerCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    DlgSelectPlayerCtl.prototype.SetColumnValueTitle = function (title) {
        this.DATA.columnValueTitle = title;
        this.Update();
        return this;
    };
    DlgSelectPlayerCtl.prototype.SetViewData = function (data) {
        this.DATA.data = data;
        this.Update();
        return this;
    };
    DlgSelectPlayerCtl.prototype.SetFilterVal = function (filterValue) {
        this.DATA.filterVal = filterValue;
        this.Update();
        return this;
    };
    return DlgSelectPlayerCtl;
}(BaseController_1.BaseController));
exports.DlgSelectPlayerCtl = DlgSelectPlayerCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSelectPlayerCtl.ts
// module id = 913
// module chunks = 0